import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id", "disabled", "loading"]
const _hoisted_2 = {
  key: 0,
  class: "loader position-absolute button-primary opacity-75"
}
const _hoisted_3 = { class: "svg-slot" }



  interface Props {
    id?: string
    disabled?: boolean
    classes?: string[]
    textClass?: string
    loading?: boolean
  }
  interface Emits {
    (e: 'buttonClick'): void
  }

  // props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    id: {},
    disabled: { type: Boolean },
    classes: { default: () => ['button-primary', 'bg-primary-blue'] },
    textClass: { default: 'text-primary-white' },
    loading: { type: Boolean }
  },
  emits: ["buttonClick"],
  setup(__props: any, { emit: __emit }) {

  const props = __props

  // emit
  const emit = __emit

  // handlers
  const handleClick = () => {
    if (props.disabled) return
    emit('buttonClick')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: props.id,
    onClick: _withModifiers(handleClick, ["prevent"]),
    class: _normalizeClass([[...props.classes, _ctx.loading && 'loading'], "position-relative"]),
    disabled: props.disabled,
    loading: props.loading
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "svg")
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["text-slot", [!props.disabled ? props.textClass : 'text-primary-white']])
    }, [
      _renderSlot(_ctx.$slots, "text")
    ], 2)
  ], 10, _hoisted_1))
}
}

})